/**
 * Hook that combines participant list building and participant actions setup.
 */

import type { ConversationResponse } from '@saaga/shared/interfaces/conversation.interface'

import type { UserLookupMap } from '@/hooks/use-org-members-lookup.hook'

import type { UseChatParticipantActionsReturn } from './use-chat-participant-actions.hook'
import { useChatParticipantActions } from './use-chat-participant-actions.hook'
import { useChatParticipants } from './use-chat-participants.hook'

interface UseChatParticipantSetupParams {
  conversationId: string | null
  conversation: ConversationResponse | undefined
  userLookup: UserLookupMap
}

interface UseChatParticipantSetupReturn {
  participantList: ReturnType<typeof useChatParticipants>
  participantActions: UseChatParticipantActionsReturn
}

export const useChatParticipantSetup = ({
  conversationId,
  conversation,
  userLookup,
}: UseChatParticipantSetupParams): UseChatParticipantSetupReturn => {
  const participantList = useChatParticipants({
    participants: conversation?.participants,
    userLookup,
  })

  const participantActions = useChatParticipantActions({
    conversationId,
    participants: conversation?.participants,
    userLookup,
  })

  return { participantList, participantActions }
}
